import {useEffect, useId, useState} from "react";
import {ThinCloseIcon} from "../../../components/icons/material-icons";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";

export const AdminsAddEditConsultNoteModal = (props: {
    active: boolean,
    closeHandler: any,
    edit: boolean,
    studentId: string,
    noteId: number,
    onDone: any,
    note: string
}) => {
    const noteId = useId();
    const [note, setNote] = useState('');
    const [error, setError] = useState(false);
    useEffect(() => {
        const isActive = props.active;
        const isEdit = props.edit;
        const n = props.note;
        if (isActive) {
            document.body.classList.add("body-no-scroll");
            setNote(isEdit ? n : '');
        } else {
            document.body.classList.remove('body-no-scroll')
        }
    }, [props.active]);
    const saveChanges = () => {
        const data = {
            note: note.trim(),
            id: props.studentId,
            noteId: props.noteId.toString(),
        };
        const isEdit = props.edit;
        if (data.note.length < 3) {
            setError(true);
            return;
        }
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/consult/notes/' + (isEdit ? 'edit' : 'add'),
            data,
            true,
            (d: {
                result: string,
                reason: string,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar(
                    isEdit ? 'یادداشت ویرایش شد.' : 'یادداشت افزوده شد.',
                    'باشه',
                    5000,
                );
                props.onDone();
                props.closeHandler();
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div><b>{props.edit ? 'ویرایش یادداشت' : 'یادداشت جدید'}</b></div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label htmlFor={noteId} data-necessary="yes">یادداشت:</label>
                        <textarea id={noteId}
                                  className={"form-control" + (error ? ' is-invalid' : '')}
                                  value={note}
                                  style={{minHeight: 200, maxHeight: 400}}
                                  onChange={e => {
                                      setNote(e.currentTarget.value);
                                      setError(false);
                                  }}
                        />
                        <div className={"invalid-feedback" + (error ? ' d-block' : ' d-none')}>
                            لطفا حداقل ۳ کاراکتر وارد کنید.
                        </div>
                        <div className="d-flex justify-content-end align-items-center" style={{marginTop: 20, gap: 5}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره یادداشت</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};